module.exports = __webpack_public_path__ + "static/media/caret_down_white.e8432e43.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/caret_down_white.svg
// module id = 942
// module chunks = 0